import React from 'react';
import { t } from 'Src/i18n';
import { classnames } from 'Utils/classnames/classnames.utils';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
type AdditionalTransportOrderButtonProps = {
  isDisabled?: boolean;
  isSelected: boolean;
  type: 'cheapest' | 'fastest';
  setSelectedOrder: () => void;
  price: string;
  time?: string;
};
export const AdditionalTransportListOrderButton = ({
  isDisabled,
  isSelected,
  type,
  setSelectedOrder,
  price,
  time,
}: AdditionalTransportOrderButtonProps) => {
  const isActive = isSelected && !isDisabled;
  const { trackClickEvent } = useTrackEvent();
  return (
    <button
      data-testid="AdditionalTransportListOrderButton"
      disabled={isDisabled}
      type="button"
      className={classnames({
        'min-h-100 rounded-12 border-1 p-15 text-start': true,
        'cursor-pointer': !isDisabled,
        'border-none bg-saffron': isActive,
        'cursor-not-allowed bg-lightGrey': isDisabled,
      })}
      onClick={() => {
        trackClickEvent(TRACK_EVENT_NAMES.CLICK_TRANSPORT_LAYER, {
          detail_click: 'change_flight_type',
          flight_type: type,
        });
        setSelectedOrder();
      }}
    >
      <p className="mb-4 text-14 font-semibold">
        {t(`booking.transport.sort.${type}Flight`)}
        {isActive && <Icon className="-mb-3 ms-5" name={ICONS.CHECK} width="1rem" />}
      </p>
      <p className="text-20 font-semibold">{price}</p>
      {time && <p className="text-12 font-normal">{time}</p>}
    </button>
  );
};
